module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/mZoom.5e09391b.svg";